<template>
  <v-card class="elevation-0">
    <div class="flex-y-center pt-4 px-4 mb-3">
      <div class="flex-1 flex-y-center">
        <span class="mr-2 flex-0" style="min-width: 80px; white-space: nowrap">表单名称：</span>
        <input
          v-model="search.name"
          class="default-input py-1 subtitle-1"
          placeholder="按表单名称搜索"
          type="text"
          style="width: 200px"
          @keyup.enter="getList()"
        >
        <v-btn class="ml-3" color="primary" depressed small @click="getList">搜索</v-btn>
        <v-btn class="ml-2" depressed small @click="resetSearch">重置</v-btn>
      </div>
      <v-btn color="#00bea9" depressed dark small @click="showAdd">
        <v-icon size="20">mdi-plus</v-icon>
        <span class="ml-1">新增表单</span>
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="paginatedList"
      :items-per-page="10"
      class="pb-5 max-width header-grey px-4"
      hide-default-footer
      item-key="id"
      no-data-text="暂无查询数据"
    >
      <template v-slot:item.index="{ index }">
        {{ (page - 1) * pageSize + index + 1 }}
      </template>
      <template v-slot:item.active="{ item }">
        <a class="mr-2" @click="onEdit(item)">编辑</a>
        <a class="mr-2" @click="onUploadTemplate(item)">上传导出模板</a>
        <a class="mr-2" @click="onDesign(item)">设计表单</a>
        <!--        <a class="mr-2" @click="onPreview(item)">预览</a>-->
        <!--        <a class="mr-2" @click="onCopy(item)">拷贝</a>-->
        <a class="mr-2" @click="onDelete(item)">删除</a>
      </template>
    </v-data-table>
    <!-- 添加分页组件 -->
    <div
      class="pagination-wrapper"
      style="display: flex; justify-content: center; padding: 16px"
    >
      <v-pagination
        v-model="page"
        :length="Math.ceil(filteredItems.length / pageSize)"
        :total-visible="7"
      />
    </div>
    <v-dialog v-model="dialog.show" width="500">
      <v-card>
        <v-card-title class="font-weight-bold">{{
          dialog.data.id ? '编辑表单' : '新增表单'
        }}</v-card-title>
        <v-divider />
        <v-card-text class="py-5">
          <div class="px-8">
            <div class="mb-6 flex-align-start">
              <div
                class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
              >
                表单名称：
              </div>
              <input
                v-model="dialog.data.name"
                class="flex-1 default-input py-1 subtitle-1"
                placeholder="表单名称"
                type="text"
              >
            </div>
            <div class="mb-6 flex-align-start">
              <div
                class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
              >
                备注：
              </div>
              <input
                v-model="dialog.data.remark"
                class="flex-1 default-input py-1 subtitle-1"
                placeholder="备注"
                type="text"
              >
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="max-width flex-y-center flex-justify-end px-4 py-2">
            <v-btn
              width="80"
              class="mr-3"
              depressed
              @click="dialog.show = false"
            >取消</v-btn>
            <v-btn width="80" color="primary" depressed @click="submit">保存</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer
      v-model="drawer.show"
      :permanent="drawer.show"
      temporary
      app
      right
      width="1600"
    >
      <div class="max-height flex-column">
        <div
          class="flex-0 flex-justify-between flex-y-center py-3 px-5"
          style="border-bottom: 1px solid #e1e1e1"
        >
          <span class="text-h6">表单设计 - {{ drawer.data && (drawer.data.name || '-') }}</span>
          <v-icon @click="drawer.show = false">mdi-close</v-icon>
        </div>
        <div class="flex-1 overflow-auto px-5 py-4">
          <div
            v-if="drawer.mode === 'design' && kfdReady"
            :key="'design-' + drawer.key"
            class="processFormDiv"
          >
            <k-form-design
              ref="kfd"
              :toolbars="['save', 'reset', 'export-label', 'import-template']"
              :show-toolbars-text="true"
              :fields="[
                'input',
                'textarea',
                'number',
                'select',
                'checkbox',
                'radio',
                'date',
                'time',
                'uploadFile',
                'switch',
                'batch',
                'text',
                'divider',
                'grid',
              ]"
              @save="onDesignSave"
              @reset="onDesignReset"
            >
              <template slot="left-action">
                <a-tooltip title="导出标签">
                  <a style="font-size: 14px" @click="handleExportLabel">
                    <a-icon type="export" class="mr-1" />导出标签
                  </a>
                </a-tooltip>
                <a-tooltip title="导入模板">
                  <a style="font-size: 14px" @click="$refs.importBtnRef.open()">
                    <a-icon type="import" class="mr-1" />导入模板
                  </a>
                </a-tooltip>
              </template>
            </k-form-design>
          </div>
          <div
            v-else-if="drawer.mode !== 'design' && drawer.buildData"
            :key="'build-' + drawer.key"
          >
            <k-form-build ref="kfb" :value="drawer.buildData" />
          </div>
        </div>
      </div>
      <importBtn
        ref="importBtnRef"
        :template-url="$api.exportFormsDesignTemplate"
        :import-url="$api.importFormsDesignTemplate"
        :parmas="{ formId: drawer.data.id }"
        :show-btn="false"
        @importOk="onDesign(drawer.data)"
      />
    </v-navigation-drawer>

    <!-- 导入导出模版 start -->
    <v-dialog
      v-model="upAndDown.show"
      persistent
      no-click-animation
      width="500px"
    >
      <v-card class="flex-column overflow-hidden">
        <v-card-title class="font-weight-bold flex-justify-between">
          <span>上传导出模版</span>
          <v-icon
            class="v-icon notranslate v-chip__close v-icon--link v-icon--right mdi mdi-close theme--light"
            @click="upAndDown.show = false"
          >mdi-close</v-icon>
        </v-card-title>
        <v-divider />
        <v-card-text class="flex-1 px-0 overflow-auto">
          <div class="flex-align-start mt-6 ml-4 mr-4">
            <div class="flex-0 flex-shrink-0 flex-justify-end mt-2">
              <span class="red--text ml-1">*</span>导入：
            </div>
            <div>
              <input
                ref="fileInput"
                class="flex-1 default-input py-1 subtitle-1"
                placeholder="文件导入"
                required
                type="file"
                @input="updateFile"
              >
              <div class="mt-2" @click="downLoadFile">
                <a href="JavaScript:void(0)">下载当前模版</a>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="max-width flex-y-center flex-justify-between">
            <div class="flex-1 flex-justify-end">
              <v-btn
                dark
                small
                color="primary"
                title="导入"
                depressed
                min-width="80"
                height="30"
                class="mr-2"
                :loading="upAndDown.loading"
                @click="upLoadFile"
              >导入</v-btn>
              <v-btn
                width="80"
                height="30"
                class
                depressed
                @click="(upAndDown.show = false), (upAndDown.params.file = '')"
              >关闭</v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 导入导出模本 end -->
  </v-card>
</template>

<script>
import {
  projectName,
  projectNumber,
  projectSponsor,
  promoterName,
} from '@/components/formDesign/form-controls.js';
import { setFormDesignConfig } from '@/components/formDesign/packages';

export default {
  name: 'ProcessForm',

  data() {
    return {
      page: 1,
      pageSize: 10,
      allList: [],
      formFields: [
        'input',
        'textarea',
        'number',
        'select',
        'checkbox',
        'radio',
        'date',
        'time',
        'uploadFile',
        'switch',
        'batch',
        'text',
        'divider',
        'grid',
      ],
      kfdReady: false,
      search: {
        name: '',
      },
      headers: [
        { text: '序号', value: 'index', width: 80 },
        { text: '表单名称', value: 'name' },
        { text: '备注', value: 'remark' },
        { text: '最后修改时间', value: 'updateTime' },
        { text: '操作', value: 'active', width: 360 },
      ],
      list: [],
      dialog: {
        show: false,
        data: {},
      },
      drawer: {
        show: false,
        data: {},
        mode: 'design',
        buildData: {},
        key: 0,
      },
      upAndDown: {
        show: false,
        loading: false,
        params: {
          id: '',
          file: null,
        },
      },
    };
  },
  computed: {
    // 过滤后的数据
    filteredItems() {
      return this.allList;
    },
    // 分页后的数据
    paginatedList() {
      const start = (this.page - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredItems.slice(start, end);
    },
  },
  mounted() {
    this.getList();
    setFormDesignConfig(
      {
        title: '套件选择',
        list: [projectName, projectNumber, projectSponsor, promoterName],
      },
      '套件选择'
    );
  },
  created() {},
  methods: {
    getList() {
      const params = { name: this.search.name };
      params.pageSize = 9999;
      this.$http.get(this.$api.formsList, { data: params }).then((res) => {
        if (res.code === 0 || res.code === 200) {
          this.allList =
            res.result && res.result.records
              ? res.result.records
              : res.result || [];
          this.page = 1;
        }
      });
    },
    resetSearch() {
      this.search.name = '';
      this.getList();
    },
    showAdd() {
      this.dialog.data = {};
      this.dialog.show = true;
    },
    onEdit(item) {
      this.dialog.data = { id: item.id, name: item.name, remark: item.remark };
      this.dialog.show = true;
    },
    submit() {
      if (!this.dialog.data || !this.dialog.data.name)
        return this.$message.warning('请输入表单名称');
      // 新增
      if (!this.dialog.data.id) {
        const payload = {
          name: this.dialog.data.name,
          remark: this.dialog.data.remark,
        };
        this.$http.post(this.$api.formsAdd, { data: payload }).then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.$message.success('新增成功');
            this.dialog.show = false;
            this.dialog.data = {};
            this.getList();
          }
        });
        return;
      }
      // 编辑
      const payload = {
        id: this.dialog.data.id,
        name: this.dialog.data.name,
        remark: this.dialog.data.remark,
      };
      this.$http.put(this.$api.formsEdit, { data: payload }).then((res) => {
        if (res.code === 0 || res.code === 200) {
          this.$message.success('保存成功');
          this.dialog.show = false;
          this.dialog.data = {};
          this.getList();
        }
      });
    },
    onDesign(item) {
      this.drawer.key = Date.now();
      this.kfdReady = false;
      this.drawer.data = { ...item };
      this.drawer.mode = 'design';
      this.drawer.buildData = null;
      this.drawer.show = true;
      this.buildData = {};
      const thiz = this;
      // this.editFormId = form_id
      this.$http
        .post(this.$api.formsGetSettings, {
          data: {
            form_id: item.id,
          },
        })
        .then((res) => {
          this.kfdReady = true;
          if (res.code === 0 || res.code === 200) {
            this.visible = true;
            this.formDesignVisible = true;
            this.formViewVisible = false;
            // this.formTitle = res.data.title,
            this.buildData = res.result.data.json_data;
            this.drawer.buildData = res.result.data.json_data;
            setTimeout(function () {
              thiz.$refs.kfd.handleSetData(res.result.data.json_data);
            }, 200);
          }
        });
    },
    onDesign2(item) {
      this.drawer.key = Date.now();
      this.kfdReady = false;
      this.drawer.data = { ...item };
      this.drawer.mode = 'design';
      this.drawer.buildData = null;
      this.drawer.show = true;
      this.buildData = {};
      const form_id = item.id;
      const thiz = this;
      // 获取表单配置
      this.$http
        .post(this.$api.formsGetSettings, {
          data: {
            form_id: item.id,
          },
        })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.editFormId = form_id;
            this.visible = true;
            // this.formDesignVisible = false
            // this.formViewVisible = true
            // this.formTitle = res.data.title;
            this.buildData = res.result.data.json_data;
            this.drawer.buildData = res.result.data.json_data;
            setTimeout(function () {
              thiz.$refs.kfd.handleSetData(res.result.data.json_data);
            }, 200);
            // this.versionOptions = res.data.version_list
            // this.currentVersion = version_id
            // this.isCurrentVersion = res.data.current_version
            // if (res.data.delete_user > 0) {
            //   this.deleteUser = true;
            // } else {
            //   this.deleteUser = false;
            // }
          }
        });
    },
    onDesign1(item) {
      this.drawer.key = Date.now();
      this.kfdReady = false;
      this.drawer.data = { ...item };
      this.drawer.mode = 'design';
      this.drawer.buildData = null;
      this.drawer.show = true;
      // 完全按照参考项目的逻辑
      var thiz = this;
      this.$http
        .post(this.$api.formsGetSettings, {
          data: {
            form_id: item.id,
          },
        })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            console.log('formsGetSettings接口返回数据:', res);

            // 按照参考项目的方式处理数据
            let jsonData = null;

            // 根据接口返回的数据结构，需要转换json_data
            if (res.result && res.result.data && res.result.data.json_data) {
              console.log('检测到json_data，需要转换数据结构');
              console.log('json_data.list:', res.result.data.json_data.list);
              console.log(
                'json_data.config:',
                res.result.data.json_data.config
              );

              // 转换数据结构，从复杂的list中提取字段
              const convertedData = this.convertJsonDataToSchema(
                res.result.data.json_data
              );
              jsonData = convertedData;
              console.log('转换后的数据:', jsonData);
            } else if (res.result && res.result.fields) {
              console.log('检测到result.fields，调用convertNewFormatToSchema');
              jsonData = this.convertNewFormatToSchema(res.result);
              console.log('使用convertNewFormatToSchema转换的数据:', jsonData);
            } else {
              // 直接使用result
              jsonData = res.result;
              console.log('使用原始数据:', jsonData);
            }

            this.kfdReady = true;
            // 按照参考项目的方式，使用setTimeout延迟设置数据
            setTimeout(function () {
              if (thiz.$refs.kfd && jsonData) {
                console.log('传递给表单设计器的数据:', jsonData);
                console.log('数据中的字段列表:', jsonData.list);
                console.log('字段列表长度:', jsonData.list?.length);

                // 验证每个字段的key
                if (jsonData.list && Array.isArray(jsonData.list)) {
                  jsonData.list.forEach((field, index) => {
                    console.log(`字段${index}:`, field);
                    console.log(
                      `字段${index}的key:`,
                      field.key,
                      '类型:',
                      typeof field.key
                    );
                    if (!field.key) {
                      console.error(`字段${index}缺少key属性`);
                    }
                  });
                }

                // 尝试修复数据，确保所有字段都有有效的key和options
                if (jsonData.list && Array.isArray(jsonData.list)) {
                  jsonData.list.forEach((field, index) => {
                    if (!field.key || typeof field.key !== 'string') {
                      field.key = `field_${Date.now()}_${index}_${Math.random()
                        .toString(36)
                        .substr(2, 5)}`;
                      console.log(`修复字段${index}的key:`, field.key);
                    }

                    // 确保options对象存在
                    if (!field.options || typeof field.options !== 'object') {
                      field.options = {
                        width: '100%',
                        defaultValue: '',
                        placeholder: '请输入',
                        disabled: false,
                        hidden: false,
                        clearable: false,
                        min: '',
                        max: '',
                        step: '',
                        precision: '',
                        type: 'text',
                      };
                      console.log(`修复字段${index}的options:`, field.options);
                    }

                    // 确保rules数组存在
                    if (!field.rules || !Array.isArray(field.rules)) {
                      field.rules = [
                        {
                          required: false,
                          message: '必填项',
                        },
                      ];
                      console.log(`修复字段${index}的rules:`, field.rules);
                    }
                  });
                }

                // 最终验证和修复数据
                if (jsonData.list && Array.isArray(jsonData.list)) {
                  jsonData.list = jsonData.list.map((field, index) => {
                    // 确保字段对象完整
                    const completeField = {
                      key: field.key || `field_${Date.now()}_${index}`,
                      model:
                        field.model ||
                        field.key ||
                        `field_${Date.now()}_${index}`,
                      type: field.type || 'input',
                      label: field.label || field.config?.label || '未命名字段',
                      options: field.options || {
                        width: '100%',
                        defaultValue: '',
                        placeholder: '请输入',
                        disabled: false,
                        hidden: false,
                        clearable: false,
                        min: '',
                        max: '',
                        step: '',
                        precision: '',
                        type: 'text',
                      },
                      rules: field.rules || [
                        {
                          required: false,
                          message: '必填项',
                        },
                      ],
                    };

                    console.log(`最终字段${index}:`, completeField);
                    return completeField;
                  });
                }

                // 强制重新渲染，确保Vue能正确识别key
                thiz.$nextTick(() => {
                  thiz.$refs.kfd.handleSetData(jsonData);
                });
              }
            }, 200);
          } else {
            console.error('获取表单设置失败:', res.message);
          }
        })
        .catch((error) => {
          console.error('获取表单设置异常:', error);
        });
    },
    // 转换json_data为表单设计器需要的格式
    convertJsonDataToSchema(jsonData) {
      try {
        console.log('开始转换json_data:', jsonData);

        const fieldList = [];

        // 遍历list中的每个项目
        if (jsonData.list && Array.isArray(jsonData.list)) {
          jsonData.list.forEach((item, index) => {
            console.log(`处理list项目${index}:`, item);

            // 检查是否有fields字段
            if (item.fields && typeof item.fields === 'object') {
              Object.keys(item.fields).forEach((fieldId, fieldIndex) => {
                const field = item.fields[fieldId];
                console.log(`处理字段${fieldIndex}:`, fieldId, field);

                if (field && field.tag) {
                  const uniqueKey = `${
                    field.tag
                  }_${Date.now()}_${index}_${fieldIndex}_${Math.random()
                    .toString(36)
                    .substr(2, 5)}`;

                  const fieldObj = {
                    key: uniqueKey,
                    model: fieldId,
                    type: field.tag,
                    label:
                      field.config?.label ||
                      field.attrs?.placeholder ||
                      '未命名字段',
                    options: {
                      width: '100%',
                      defaultValue: field.attrs?.defaultValue || '',
                      placeholder: field.attrs?.placeholder || '请输入',
                      disabled: field.attrs?.disabled || false,
                      hidden: field.attrs?.hidden || false,
                      clearable: false,
                      min: field.attrs?.min || '',
                      max: field.attrs?.max || '',
                      step: field.attrs?.step || '',
                      precision: field.attrs?.precision || '',
                      type: field.attrs?.type || 'text',
                    },
                    rules: [
                      {
                        required: field.attrs?.required || false,
                        message: '必填项',
                      },
                    ],
                  };

                  console.log(`字段${fieldIndex}的label:`, fieldObj.label);
                  fieldList.push(fieldObj);
                }
              });
            }
          });
        }

        const config = jsonData.config || {
          layout: 'horizontal',
          labelCol: { span: 4 },
          wrapperCol: { span: 18 },
          hideRequiredMark: false,
          customStyle: '',
        };

        const schema = {
          list: fieldList,
          config: config,
        };

        console.log('转换后的schema:', schema);
        return schema;
      } catch (error) {
        console.error('转换json_data失败:', error);
        return {
          list: [],
          config: {
            layout: 'horizontal',
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            hideRequiredMark: false,
            customStyle: '',
          },
        };
      }
    },
    // 将新格式数据转换为表单设计器需要的格式
    convertNewFormatToSchema(data) {
      try {
        console.log('开始转换新格式数据:', data);

        // 提取字段信息
        const fields = data.fields || {};
        console.log('提取的fields:', fields);
        console.log('fields类型:', typeof fields);
        console.log('fields是否为对象:', typeof fields === 'object');

        // 构建字段列表
        const fieldList = [];

        // 遍历所有字段
        Object.keys(fields).forEach((fieldId, index) => {
          const field = fields[fieldId];
          console.log(`处理字段${index}:`, fieldId, field);
          console.log(`字段${index}的config:`, field.config);
          console.log(`字段${index}的config.label:`, field.config?.label);
          console.log(`字段${index}的attrs:`, field.attrs);
          console.log(
            `字段${index}的attrs.placeholder:`,
            field.attrs?.placeholder
          );

          if (field && field.tag) {
            // 确保key是唯一的，使用索引和时间戳
            const uniqueKey = `${
              field.tag
            }_${Date.now()}_${index}_${Math.random()
              .toString(36)
              .substr(2, 5)}`;

            // 构建字段对象，完全按照参考项目的格式
            const fieldObj = {
              key: uniqueKey,
              model: fieldId,
              type: field.tag,
              label:
                field.config?.label || field.attrs?.placeholder || '未命名字段',
              options: {
                width: '100%',
                defaultValue: field.attrs?.defaultValue || '',
                placeholder: field.attrs?.placeholder || '请输入',
                disabled: field.attrs?.disabled || false,
                hidden: field.attrs?.hidden || false,
                clearable: false,
                // 添加更多必要的options属性
                min: field.attrs?.min || '',
                max: field.attrs?.max || '',
                step: field.attrs?.step || '',
                precision: field.attrs?.precision || '',
                type: field.attrs?.type || 'text',
              },
              rules: [
                {
                  required: field.attrs?.required || false,
                  message: '必填项',
                },
              ],
            };

            // 确保key是字符串且不为空
            if (!fieldObj.key || typeof fieldObj.key !== 'string') {
              fieldObj.key = `field_${Date.now()}_${index}`;
            }

            // 确保options对象完整
            if (!fieldObj.options) {
              fieldObj.options = {
                width: '100%',
                defaultValue: '',
                placeholder: '请输入',
                disabled: false,
                hidden: false,
                clearable: false,
                min: '',
                max: '',
                step: '',
                precision: '',
                type: 'text',
              };
            }

            // 确保rules数组存在
            if (!fieldObj.rules || !Array.isArray(fieldObj.rules)) {
              fieldObj.rules = [
                {
                  required: false,
                  message: '必填项',
                },
              ];
            }

            console.log(
              `字段 ${index} 的key:`,
              fieldObj.key,
              '类型:',
              typeof fieldObj.key
            );
            console.log(`字段 ${index} 的label:`, fieldObj.label);
            console.log(`字段 ${index} 的options:`, fieldObj.options);
            fieldList.push(fieldObj);
          }
        });

        // 构建配置对象，完全按照参考项目的格式
        const config = {
          layout: 'horizontal',
          labelCol: { span: 4 },
          wrapperCol: { span: 18 },
          hideRequiredMark: false,
          customStyle: '',
        };

        const schema = {
          list: fieldList,
          config: config,
        };

        console.log('转换后的schema:', schema);
        console.log('字段列表详情:', fieldList);
        console.log('字段数量:', fieldList.length);
        console.log('第一个字段详情:', fieldList[0]);
        console.log('第一个字段的key:', fieldList[0]?.key);
        console.log('第一个字段的model:', fieldList[0]?.model);

        // 验证所有字段的key
        fieldList.forEach((field, index) => {
          console.log(
            `字段${index} key:`,
            field.key,
            '类型:',
            typeof field.key,
            '是否为空:',
            !field.key
          );
          if (!field.key || typeof field.key !== 'string') {
            console.error(`字段${index}的key无效:`, field.key);
          }
        });

        return schema;
      } catch (error) {
        console.error('转换新格式数据失败:', error);
        // 返回默认格式
        return {
          list: [],
          config: {
            layout: 'vertical',
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            hideRequiredMark: false,
            customStyle: '',
          },
        };
      }
    },
    onDesignSave(values) {
      const payload = {
        form_id: this.drawer.data.id,
        use_version: false,
        form_data: values,
      };
      this.$http
        .post(this.$api.formsSaveSettings, { data: payload })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.$message.success(res.message || '保存成功', 2.5);
            // 提交后清空设计器表单
            if (
              this.$refs.kfd &&
              typeof this.$refs.kfd.handleSetData === 'function'
            ) {
              this.$refs.kfd.handleSetData({
                list: [],
                config: {
                  layout: 'horizontal',
                  labelCol: { span: 4 },
                  wrapperCol: { span: 18 },
                  hideRequiredMark: false,
                  customStyle: '',
                },
              });
            }
            // 关闭设计器抽屉
            this.drawer.show = false;
            this.drawer.data = {};
            // 刷新表单列表
            this.getList();
          } else {
            this.$message.error(res.message || '保存失败', 2.5);
          }
        })
        .catch((error) => {
          this.$message.error('保存失败', 2.5);
          console.error('保存表单设计失败:', error);
        });
    },
    onDesignReset() {
      // 仅保留抽屉开启与界面清空，不做自动保存
      this.$message.success('已清空（未保存）', 2.0);
    },
    onPreview(item) {
      this.$message.info('TODO: 预览表单');
    },
    onCopy(item) {
      this.$message.success('已拷贝');
    },
    onDelete(item) {
      this.$confirm({ text: '是否确认删除？' }).then((vm) => {
        const payload = { id: item.id };
        this.$http
          .delete(this.$api.formsDelete, { data: payload })
          .then((res) => {
            if (res.code === 0 || res.code === 200) {
              vm && (vm.show = false);
              this.$message.success('删除成功');
              this.dialog.show = false;
              this.getList();
            }
          })
          .catch(() => {
            vm && (vm.show = false);
          });
      });
    },
    // 导出标签
    handleExportLabel() {
      this.$http
        .blobGet(this.$api.exportFormsLabel, {
          data: { id: this.drawer.data.id },
        })
        .then((res) => {
          this.dowmLoad(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 下载
    dowmLoad(res) {
      const _r = res;
      const _this = this;
      // const blob = new Blob([_res])
      const blob = new Blob([_r.data], { type: 'application/octet-stream' });
      const href = window.URL.createObjectURL(blob);
      try {
        const downloadElement = document.createElement('a');
        // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = decodeURI(
          _r.headers['content-disposition'].slice(
            _r.headers['content-disposition'].indexOf('filename=') + 9
          )
        ); // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
        _this.$forceUpdate();
        _this.$message.success('下载完成！');
        _this.upAndDown.show = false;
      } catch (err) {
        _this.$message.error('当前没有上传模版');
      }
    },
    onUploadTemplate(item) {
      this.upAndDown.params.id = item.id;
      this.upAndDown.params.file = null;
      this.upAndDown.show = true;
      this.$nextTick(() => {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
      });
    },
    downLoadFile() {
      this.$http
        .blobGet(this.$api.exportFormsTemplateById, {
          data: { id: this.upAndDown.params.id },
        })
        .then((res) => {
          this.dowmLoad(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateFile(e) {
      this.upAndDown.params.file = e.target.files[0];
    },
    upLoadFile() {
      this.upAndDown.loading = true;
      const form = new FormData();
      form.append('file', this.upAndDown.params.file);
      form.append('id', this.upAndDown.params.id);
      this.$http
        .post(this.$api.importFormsExportTempalte, {
          data: form,
        })
        .then(() => {
          this.$message.success('上传成功');
          this.upAndDown.show = false;
        })
        .finally(() => {
          this.upAndDown.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  width: 90px;
  color: #777;
}
</style>
<style lang="scss">
.processFormDiv {
  /* div[role='tablist']:nth-child(3) {
    display: none !important;
  } */

  header.header {
    display: none;
  }
}
</style>
